"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _deepfind = _interopRequireDefault(require("./deepfind"));

var _loglevel = _interopRequireDefault(require("loglevel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(prop, field) {
  return function (_ref) {
    var theme = _ref.theme;

    if (!field) {
      if (theme.hasOwnProperty(prop)) {
        return theme[prop];
      }

      return null;
    }

    if (!(0, _deepfind["default"])(theme, [prop, field].join("."))) {
      _loglevel["default"].warn("Could not find", field, "in", prop);

      return null;
    }

    return theme[prop][field];
  };
};

exports["default"] = _default;